<template>
  <table
    class="bookingPriceToPayTable"
    :class="{ BookingPriceToPay: !noContainerStyle }">
    <tbody :class="{ 'BookingPriceToPay-background': !noContainerStyle }">
      <!-- Mobile -->
      <tr>
        <td>
          <div class="BookingPriceToPay-row">
            <div class="BookingPriceToPay-mobileLabelContainer">
              <ai-typo as="span" variant="heading-04" color="gold-900">
                {{ $t('booking.payment.priceToPay.total') }}
              </ai-typo>
              <ai-typo as="span" variant="legal-regular" color="gold-900">
                {{ $t('booking.payment.priceToPay.amountDue') }}
              </ai-typo>
            </div>

            <div class="BookingPriceToPay-mobileLabelContainer">
              <ai-amount
                text-align="right"
                :amount="inUserCurrency.amount as number"
                :symbol="inUserCurrency.currency?.code as string" />
              <ai-amount
                v-if="!inUserCurrency?.sameCurrency"
                text-align="right"
                :amount="amount"
                :symbol="currencyConfig?.code as string"
                main-typo="paragraph-04-regular"
                decimal-typo="paragraph-04-regular" />
            </div>
          </div>
        </td>
      </tr>
    </tbody>
    <tfoot>
      <tr>
        <td>
          <ai-typo
            class="BookingRecap-taxesIncluded"
            as="span"
            variant="legal-regular">
            {{ $t('booking.recap.prices.taxesIncluded') }}
          </ai-typo>
        </td>
      </tr>
    </tfoot>
  </table>
</template>

<script setup lang="ts">
import type { Currency } from '~~/domains/graphql';
import { useCurrenciesMap } from '~~/domains/referential';

type Props = {
  amount?: number;
  currency?: Currency['code'] | string;
  noContainerStyle?: boolean;
};

const props = defineProps<Props>();

const currencies = useCurrenciesMap();

const currencyConfig = computed(
  () => currencies.value?.[props.currency as Currency['code']],
);

const computedAmount = computed(() => props.amount ?? 0);

const inUserCurrency = useConvertToUserCurrency(computedAmount, props.currency);
</script>

<style scoped lang="scss">
@use '@/assets/styles/utilities/constants';
@use '@/assets/styles/utilities/mq';
@use '@/assets/styles/utilities/colors';

.bookingPriceToPayTable {
  width: 100%;
}

.BookingPriceToPay {
  display: flex;
  flex-direction: column;
  background-color: white;
  padding: constants.$inner-03;

  @media (mq.$from-medium) {
    padding: constants.$inner-04;
  }
}

.BookingPriceToPay-mobileLabelContainer {
  display: flex;
  flex-direction: column;
}

.BookingPriceToPay-background {
  background-color: colors.$gold-100;
  padding: constants.$padding-02;
}

.BookingPriceToPay-row {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
}
.BookingRecap-taxesIncluded {
  display: block;
  text-align: right;
}
</style>
